<template>
  <span class="release-version" data-testid="release-version">{{ labels.version }} {{ release.version }} · {{ stageLabel }}</span>
</template>
<script setup>
import { computed } from 'vue';
import store from '@/store';
import release from '@/release.json';
const labels = computed(() => ({
  pt: { version: 'Versão', testing: 'Testes', production: 'Produção', candidate: 'Candidato — não publicado em produção' },
  es: { version: 'Versión', testing: 'Pruebas', production: 'Producción', candidate: 'Candidato — no publicado en producción' },
  en: { version: 'Version', testing: 'Testing', production: 'Production', candidate: 'Candidate — not published to production' },
}[store.getters.getUserLang] || { version: 'Version', testing: 'Testing', production: 'Production', candidate: 'Candidate — not published to production' }));
const stageLabel = computed(() => labels.value[release.stage] || labels.value.candidate);
</script>
